import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxCSVParserError, NgxCsvParser } from 'ngx-csv-parser';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin, Observable, Subject } from 'rxjs';
import { CreateCustomer, CustomerContact } from 'src/app/domain/Customer';
import { CustomerService, CreateMultpleCustomerRequest, UpdateCustomer } from 'src/app/services/customer.service';

@Component({
  selector: 'app-import-customer-dialog',
  templateUrl: './import-customer-dialog.component.html',
  styleUrls: ['./import-customer-dialog.component.scss'],
})
export class ImportCustomerDialogComponent implements OnInit {

  constructor(private dialogRef: DynamicDialogRef, private csvParser: NgxCsvParser, private customerService: CustomerService) {

  }

  hasHeader: boolean = false;
  csvRecords: Array<any> = [];


  delimiter: string = ';';
  loading = false;
  columnDefinition = {
    customerNo: 0,
    name: 1,
    registrationNumber: 2,
    street: 3,
    zipCode: 4,
    city: 5,
    countryCode: 6,
    contactName: 7,
    contactPhone: 8,
    contactEmail: 9,
    note: 10,
  };

  customers: CreateCustomer[] = [];
  status: any[] = [];

  @ViewChild('fileImportInput') fileImportInput: any;

  ngOnInit(): void { }

  fileChangeListener($event: any): void {
    const files = $event.files;
    this.csvParser
      .parse(files[0], {
        header: false,
        delimiter: this.delimiter,
        encoding: 'utf8',
      })
      .pipe()
      .subscribe({
        next: (result: Array<any>) => {
          this.csvRecords = result; //$.next(result);
          this.mapFields();
        },
        error: (error: NgxCSVParserError) => {
          console.error('Error', error);
        },
      });
  }

  mapFields() {
    this.customers = [];
    this.csvRecords.forEach((record) => {
      if (record[0] != "Kundenr") {
        let exsist = this.CheckExsitingCustomer(record[this.columnDefinition.customerNo])
        this.customers.push({
          customerAddreses: {
            street: record[this.columnDefinition.street],
            zipCode: record[this.columnDefinition.zipCode],
            city: record[this.columnDefinition.city],
            countryCode: record[this.columnDefinition.countryCode],
            longitude: 0,
            latitude: 0,
          },
          customerNo: record[this.columnDefinition.customerNo],
          name: record[this.columnDefinition.name],
          registrationNumber: record[this.columnDefinition.registrationNumber],
          contactName: record[this.columnDefinition.contactName],
          contactPhone: record[this.columnDefinition.contactPhone],
          contactEmail: record[this.columnDefinition.contactEmail],
          note: record[this.columnDefinition.note],
          exsits: exsist,
          CustomerId: exsist ? this.FindCustomerId(record[this.columnDefinition.customerNo]) : null
        } as CreateCustomer);
      }
    });
  }

  onSubmit() {
    let CustomerToCreate = this.customers.filter(x => x.exsits == false);
    let CustomerToUpdate = this.customers.filter(x => x.exsits == true);

    CustomerToCreate.forEach(x => this.status.push(""));
    CustomerToUpdate.forEach(x => this.status.push(""));

    // let grouped = this.groupBy(CustomerToCreate, x => x.customerNo);

    let grouped = this.groupBy(CustomerToCreate, (x, index) => {
      const customerNo = x.customerNo?.trim();
      return customerNo ? customerNo : `__empty_${index}`;
    });

    let requests: CreateMultpleCustomerRequest[] = Array.from(grouped.values())
      .map(group => ({
        CustomerToCreate: group.map(x => {
          return {
            customerAddreses: {
              city: x.customerAddreses.city,
              countryCode: x.customerAddreses.countryCode,
              street: x.customerAddreses.street,
              validationSource: x.customerAddreses.ValidationSource,
              zipCode: x.customerAddreses.zipCode,
              latitude: 0,
              longitude: 0,
            },
            contactEmail: x.contactEmail,
            contactName: x.contactName,
            contactPhone: x.contactPhone,
            customerNo: x.customerNo,
            name: x.name,
            sendLabel: x.sendLabel,
            registrationNumber: x.registrationNumber,
            addressIds: new Array<string>(),
            CustomerId: "",
            exsits: false,
            note: x.note,
            serviceCodes:x.serviceCodes
          }
        })
      }));
    this.loading = true;
    forkJoin(
      requests.map(request =>
        this.customerService.createcustomerwithmulplecontacts(request)
      )
    ).subscribe({
      next: responses => {
        this.loading = false;
        this.customerService.getCustomers()
        this.dialogRef.close();
        console.debug('Created all customers', responses);
      },
      error: err => {
        console.error('Failed creating customers', err);
      }
    });

    CustomerToUpdate.forEach((x, i) => {
      this.customerService.updateCustomer({ id: x.CustomerId, customerNo: x.customerNo, registrationNumber: x.registrationNumber, name: x.name, note: x.note } as UpdateCustomer).subscribe({
        next: (res) => {
          let temp = { email: x.contactEmail, name: x.contactName, phone: x.contactPhone, sendLabel: x.sendLabel } as CustomerContact;
          if (temp.email || temp.phone || temp.name) {
            this.customerService.updateContactPerson(temp, x.CustomerId).subscribe({
              next: () => {
                this.status[CustomerToCreate.length + i] = 'success';
              },
              error: (error) => {
                this.status[CustomerToCreate.length + i] = 'error';
                console.error("UpdateContactPerson Failed: ", error)
              },
            }
            );
          }
        },
        error: (error) => {
          this.status[CustomerToCreate.length + i] = 'error';
          console.error("UpdateCustomer Failed: ", error)
        },
      });
    });


    // for (let i = 0; i < this.customers.length; i++) {
    //   const customer = this.customers[i];
    //   this.status[i] = 'pending';
    //   this.customerService.create(customer).subscribe({
    //     next: (res) => {
    //       this.status[i] = 'success';
    //     },
    //     error: (error) => {
    //       this.status[i] = 'error';
    //     },
    //   });
    // }
  }

  CheckExsitingCustomer(custoemrNo: any) {
    return this.customerService.CustomerNos.filter(x => x.customerNo == custoemrNo).length > 0;
  }
  FindCustomerId(customerNo: string) {
    return this.customerService.CustomerNos.find(x => x.customerNo == customerNo).id;
  }

  getStatus(rowIndex) {
    return this.status[rowIndex] ?? 'pending';
  }

  groupBy<T, TKey extends string | number>(items: T[], keySelector: (item: T, index: number) => TKey): Map<TKey, T[]> {

    return items.reduce((map, item, index) => {
      const key = keySelector(item, index);

      if (!map.has(key)) {
        map.set(key, []);
      }

      map.get(key)!.push(item);

      return map;
    }, new Map<TKey, T[]>());
  }
}
